import { graphql } from 'react-relay';
import type { GraphQLTaggedNode } from 'react-relay';

import { useEditorContentFragment } from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';
import type { EditorContentFragmentResult } from '@confluence/editor-content-unified-query/entry-points/useEditorContentFragment.ts';

import type { CoverPictureQuery$data } from './__generated__/CoverPictureQuery.graphql.ts';
import type { useCoverPictureFragment_content$key } from './__generated__/useCoverPictureFragment_content.graphql.ts';

// Copy of CoverPictureQuery_content for EditorContentUnifiedQuery: View Page spreads the shared
// fragment @relay(mask: false), which rules out @catch on it. Kept equal by a parity test.
const coverPictureFragmentNode: GraphQLTaggedNode = graphql`
	fragment useCoverPictureFragment_content on Content @catch {
		id
		coverPictureProperties: properties(
			keys: ["cover-picture-id-draft", "cover-picture-id-published"]
		) {
			nodes {
				id
				key
				value
				version {
					number
				}
			}
		}
	}
`;

/**
 * The cover picture from EditorContentUnifiedQuery in the shape of CoverPictureQuery data. When the
 * fragment is provided, its reader skips CoverPictureQuery, whose refetch still updates the records
 * the fragment reads.
 */
export function useCoverPictureFragment({
	contentId,
}: {
	contentId: string;
}): EditorContentFragmentResult<CoverPictureQuery$data> {
	return useEditorContentFragment<useCoverPictureFragment_content$key, CoverPictureQuery$data>(
		'coverPictureFragment',
		coverPictureFragmentNode,
		{
			contentId,
			mapData: (value) => ({
				content: { nodes: [{ id: value.id, properties: value.coverPictureProperties }] },
			}),
		},
	);
}
